import * as Api from '@/helpers/restApi'
import { unwrapFormEditorHtml } from '@/helpers/unwrapEditorHtml.js'

export default {
  state: {
    NewsDataTable: []
  },
  getters: {
    getNewsDataTable: state => state.NewsDataTable
  },
  mutations: {
  },
  actions: {
    setNewsDataTable ({ state, dispatch }) {
      // ПОЛУЧАЕМ ОБЪЕКТ ДЛЯ таблицы со страницы новостей
      Api.getApi({
        url: '/api/Articles'
      })
        .then((data) => {
          if (data.Succeeded) {
            state.NewsDataTable = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setStatusNewsTable ({ dispatch }, obj) {
      // публикуем и снимаем с публикации прямо из таблицы
      Api.putApi({
        url: `/api/Articles/SetStatuses/${obj.Id}`,
        payload: obj
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setNewsDataTable')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setNewsForm ({ commit, dispatch }, id) {
      // получаем объект тела новости для редактир или созд новой
      return Api.getApi({
        url: `/api/Articles/GetForm/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetFormData', data.Data)
            console.log('data.Data: ', data.Data)
            // глубокое копирование оригинального объекта
            commit('SetOriginFormData', data.Data)
            commit('SetShowSelectedTags', data.Data.InnerTags)
            commit('SetShowSelectedKeywords', data.Data.SearchTags)
            dispatch('setClearCacheInnerTagNews')
            dispatch('setClearCacheInnerKeywordsNews')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setSaveNews ({ commit, dispatch }, form) {
      const payload = unwrapFormEditorHtml(form)
      return Api.putApi({
        url: `/api/Articles/PutForm/${form.Id}`,
        payload
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
            return Promise.reject(new Error('setSaveNews failed'))
          }
          const newId = data.Data.Value
          commit('SetFormDataId', newId)
          const deferredPromise = payload.DefferedDate !== null
            ? dispatch('setDefferedDate', { Value: payload.DefferedDate, Id: newId })
            : Promise.resolve()
          return deferredPromise.then(() => dispatch('setNewsForm', newId))
        })
    },
    setDeleteNews ({ dispatch }, id) {
      // удаление новости из таблицы
      Api.deleteApi({
        url: `/api/Articles/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setNewsDataTable')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCloneNews ({ dispatch }, id) {
      // клонирование новости из таблицы
      Api.getApi({
        url: `/api/Articles/CloneArticle/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setNewsDataTable')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setToggleNewsPublish ({ getters, dispatch }, val) {
      // снятие с публикации и опубликование из страницы
      // редактора
      Api.putApi({
        url: `/api/Articles/TooglePublish/${getters.getFormData.Id}`,
        payload: { Value: val }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDefferedDate ({ dispatch }, obj) {
      // Для установления отложенной даты публикации
      return Api.putApi({
        url: `/api/Articles/SetDefferedDate/${obj.Id}`,
        payload: { Value: obj.Value }
      })
        .then((data) => {
          if (data.Succeeded) {
            // state.FormData.Id = data.Data.Value
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
